<bv-dialog
  [open]="open"
  [closeOnBackdrop]="false"
  [closeOnEscape]="false"
>
  <bv-dialog-title>{{ "TC_NEW_TITLE" | translate }}</bv-dialog-title>

  <bv-dialog-body class="tc-acceptance-body">
    <bv-stack space="4">
      <p class="tc-acceptance-intro">{{ "TC_NEW_BODY" | translate }}</p>

      <div class="tc-acceptance-docs">
        <a
          [href]="termsUrl"
          target="_blank"
          rel="noopener"
          class="tc-acceptance-doc-link"
        >
          <span>{{ "TERMS_AND_CONDITIONS" | translate }}</span>
          <svg
            class="tc-acceptance-doc-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
          </svg>
        </a>
        <a
          [href]="privacyUrl"
          target="_blank"
          rel="noopener"
          class="tc-acceptance-doc-link"
        >
          <span>{{ "ADMIN_PRIVACY_POLICY" | translate }}</span>
          <svg
            class="tc-acceptance-doc-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
          </svg>
        </a>
      </div>

      <bv-checkbox id="tc-acceptance-checkbox" [(ngModel)]="acceptedCheckbox">
        {{ "TC_ACCEPT_BOTH" | translate }}
      </bv-checkbox>
    </bv-stack>
  </bv-dialog-body>

  <bv-dialog-footer>
    <button
      id="btn_tc_logout"
      bv-button
      variant="ghost"
      (click)="onLogout()"
    >
      {{ "LOGOUT" | translate }}
    </button>
    <button
      id="btn_tc_continue"
      bv-button
      variant="primary"
      [disabled]="!acceptedCheckbox"
      (click)="onContinue()"
    >
      {{ "CONTINUE" | translate }}
    </button>
  </bv-dialog-footer>
</bv-dialog>
